// @flow strict

import * as React from 'react'
import { type PropsWithChildren } from '@mondough/public-web-components'
import styles from './PaidTriptych.module.scss'
import SubtitleSection from '../SubtitleSection'
import { MarkdownContent } from '../MarkdownContent'
import { type TriptychSectionProps } from '../TriptychSection'
import PaidSectionWrapper from '../PaidSectionWrapper'

const PaidTriptych = ({
  sections,
  reverse,
  children,
  flags,
}: PropsWithChildren<
  TriptychSectionProps,
  React.Element<typeof SubtitleSection>,
>) => (
  <PaidSectionWrapper contentClassName={styles.baseContent} leaveLastChildOut>
    {children}
    <div className={styles.centerContentWrapper}>
      {sections.map(({ title, text, iconURL }) => {
        return (
          <div className={styles.column} key={title}>
            <img alt="" src={iconURL} className={styles.icon} />
            {children ? (
              <h3 className={styles.title}>{title}</h3>
            ) : (
              <h2 className={styles.title}>{title}</h2>
            )}
            <MarkdownContent className={styles.copy}>{text}</MarkdownContent>
          </div>
        )
      })}
    </div>
    {flags && flags.isVirtualCards === 'true' && (
      <div className={styles.cardRunnnerWrapper}>
        <div className={styles.slidingBackground} />
      </div>
    )}
  </PaidSectionWrapper>
)

export default PaidTriptych
